import { render, staticRenderFns } from "./TalkSlot.vue?vue&type=template&id=64cf51ff"
import script from "./TalkSlot.vue?vue&type=script&lang=js"
export * from "./TalkSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports